import { mdiAccountGroup } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/components/administration"
import type { OrgaViewFrameContext } from "../../../../context"
import { isSubscriptionRestricted } from "../../../../_shared/_logic/access"

export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "users",
  title: "Benutzer",
  tooltip:
    "Mitarbeiter einladen, Benutzerkonten verwalten und Rollen sowie Zugriffsrechte festlegen.",
  icon: mdiAccountGroup,
  routeSegment: "users",
  getPages: (context) =>
    !isSubscriptionRestricted(context) &&
    (context.permissions.allows("core.users", "view") ||
      context.permissions.allows("core.users", "manage"))
      ? [
          {
            id: "users",
            title: "Benutzer",
            path: "",
            testId: "controlAdmin.organizationView.tab.users",
          },
        ]
      : [],
}
